import React from "react";
import { Field, TextInput } from "@streeteasy/design-system";
import { TextArea } from "@streeteasy/design-system/form/TextAreaField";
import { Formik } from "formik";
import { func, shape, string } from "prop-types";

import {
  useContactFormBehavior,
  useContactFormData
} from "../../redux/hooks/contactFormHooks";
import { listingAgentContactForm } from "../../schemas/listingAgentContactForm";
import TermsMessage from "../TermsMessage";
import * as S from "./styled";

const ListingAgentContactForm = ({
  className,
  handleCancelClick,
  initialFormValues
}) => {
  const { contactListingAgent } = useContactFormBehavior();
  const { errors: externalValidationErrors } = useContactFormData();

  return (
    <S.FormContainer className={className}>
      <Formik
        initialValues={initialFormValues}
        onSubmit={values => {
          contactListingAgent(values);

          return false;
        }}
        validateOnBlur={false}
        validateOnChange={false}
        validationSchema={listingAgentContactForm}
      >
        {({ errors, handleChange, handleSubmit, isSubmitting, values }) => (
          <S.Form>
            <div>
              <S.FieldContainer>
                <Field
                  error={errors.name}
                  hint="required"
                  id="name"
                  isValid={!errors.name}
                  label="Name"
                >
                  <TextInput
                    name="name"
                    onChange={handleChange}
                    required
                    type="text"
                    value={values.name}
                  />
                </Field>
              </S.FieldContainer>
              <S.FieldContainer>
                <Field
                  error={errors.phone || externalValidationErrors?.sender_phone}
                  hint="required"
                  id="phone"
                  isValid={
                    !errors.phone && !externalValidationErrors?.sender_phone
                  }
                  label="Phone"
                  onChange={handleChange}
                >
                  <TextInput
                    name="phone"
                    onChange={handleChange}
                    required
                    type="text"
                    value={values.phone}
                  />
                </Field>
              </S.FieldContainer>
              <S.FieldContainer>
                <Field
                  error={errors.email || externalValidationErrors?.sender_email}
                  hint="required"
                  id="email"
                  isValid={
                    !errors.email && !externalValidationErrors?.sender_email
                  }
                  label="Email"
                >
                  <TextInput
                    name="email"
                    onChange={handleChange}
                    required
                    type="text"
                    value={values.email}
                  />
                </Field>
              </S.FieldContainer>
              <S.FieldContainer>
                <Field
                  error={
                    errors.message ||
                    externalValidationErrors?.question_required
                  }
                  hint="required"
                  id="message"
                  isValid={
                    !errors.message &&
                    !externalValidationErrors?.question_required
                  }
                  label="Message"
                >
                  <TextArea
                    name="message"
                    onChange={handleChange}
                    required
                    value={values.message}
                  />
                </Field>
              </S.FieldContainer>
            </div>
            <TermsMessage />
            <S.ButtonContainer>
              <S.CancelButton
                disabled={isSubmitting}
                onClick={handleCancelClick}
                type="button"
              >
                Cancel
              </S.CancelButton>
              <S.SubmitButton
                disabled={isSubmitting}
                onClick={handleSubmit}
                type="submit"
              >
                Send Message
              </S.SubmitButton>
            </S.ButtonContainer>
          </S.Form>
        )}
      </Formik>
    </S.FormContainer>
  );
};

ListingAgentContactForm.propTypes = {
  className: string,
  handleCancelClick: func.isRequired,
  initialFormValues: shape({
    email: string,
    message: string,
    name: string,
    phone: string
  })
};

ListingAgentContactForm.defaultProps = {
  className: null,
  initialFormValues: {
    email: "",
    message: "",
    name: "",
    phone: ""
  }
};

export default ListingAgentContactForm;
